import * as React from 'react';
import { DrawerContext } from './DrawerProvider';

export const useDrawerContext = () => {
  const context = React.useContext(DrawerContext);

  if (context === undefined) {
    throw new Error('useDrawerContext must be used within a DrawerProvider');
  }

  return context;
};

export default useDrawerContext;
